import { steps } from './steps'
import { useOnBoard } from '../../../../components/Onboard/useOnBoard'

export const useFilterOnBoarding = ({ enabled }) => useOnBoard({ storageKey: 'onboarding_filter_list', steps, enabled })
